var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMess(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Groupe_80",
    "data-name": "Groupe 80",
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.5,
    height: 18.5,
    viewBox: "0 0 18.5 18.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_82",
    "data-name": "Trac\\xE9 82",
    d: "M6,18.828V11.945a1.543,1.543,0,0,1,.686-1.283l5.4-3.6a1.537,1.537,0,0,1,1.711,0l5.4,3.6a1.543,1.543,0,0,1,.686,1.283v6.884M6,18.828A1.541,1.541,0,0,0,7.542,20.37H18.333a1.541,1.541,0,0,0,1.542-1.542M6,18.828l5.2-3.469m8.672,3.469-5.2-3.469M6,11.891l5.2,3.469m8.672-3.469-5.2,3.469m0,0-.879.586a1.537,1.537,0,0,1-1.711,0l-.879-.586",
    transform: "translate(-3.688 -4.182)",
    fill: "none",
    stroke: "#005151",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_83",
    "data-name": "Trac\\xE9 83",
    d: "M0,0H18.5V18.5H0Z",
    fill: "none"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMess);
export default __webpack_public_path__ + "static/media/mess.9014577392b85f9c0a200b7f7efa44fe.svg";
export { ForwardRef as ReactComponent };